import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../../css/common.css';
import '../../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../../store/Slices/formSlice';
import useValidation from '../../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function ItalyEnglish() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Italy') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    //paragraph
    const [companyName, setCompanyName] = useState();
    const [city, setCity] = useState();
    const [street, setStreet] = useState();
    const [streetNumber, setStreetNumber] = useState();
    const [zip, setZip] = useState();
    const [province, setProvince] = useState();
    const [vat, setVat] = useState();
    const [companyRegistrationNumber, setCompanyRegistrationNumber] = useState();
    const [companyRegistrationName, setCompanyRegistrationName] = useState();
    const [physicalCode, setPhysicalCode] = useState();
    const [rea, setRea] = useState();
    const [authorisedPerson, setAuthorisedPerson] = useState();
    const [idNumber, setIdNumber] = useState();
    const [role, setRole] = useState();
    const [birthplace, setBirthplace] = useState();
    const [dob, setDob] = useState();
    const [contractNumber, setContractNumber] = useState();
    const [carrierName, setCarrierName] = useState();
    const [carrierAddress, setCarrierAddress] = useState();
    // //single num
    const [singleNum, setSingleNum] = useState('');
    const [singleType, setSingleType] = useState('');
    const [secretCode, setSecretCode] = useState('');
    //range
    const [rangeType, setRangeType] = useState();
    //date
    const [date, setDate] = useState();

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#companyName').value = form?.country?.customerDetails?.company_name ?? '';
        document.querySelector('#city').value = form?.country?.customerDetails?.city ?? '';
        document.querySelector('#street').value = form?.country?.customerDetails?.street ?? '';
        document.querySelector('#streetNumber').value = form?.country?.customerDetails?.street_num ?? '';
        document.querySelector('#zip').value = form?.country?.customerDetails?.zip ?? '';
        document.querySelector('#province').value = form?.country?.customerDetails?.province ?? '';
        document.querySelector('#vat').value = form?.country?.customerDetails?.vat ?? '';
        document.querySelector('#companyRegistrationNumber').value = form?.country?.customerDetails?.company_registration_num ?? '';
        document.querySelector('#companyRegistrationName').value = form?.country?.customerDetails?.company_registration_name ?? '';
        document.querySelector('#physicalCode').value = form?.country?.customerDetails?.physical_code ?? '';
        document.querySelector('#rea').value = form?.country?.customerDetails?.rea ?? '';
        document.querySelector('#authorisedPerson').value = form?.country?.authorizedPersonDetails?.authorised_person ?? '';
        document.querySelector('#idNumber').value = form?.country?.authorizedPersonDetails?.id_num ?? '';
        document.querySelector('#role').value = form?.country?.authorizedPersonDetails?.role ?? '';
        document.querySelector('#birthplace').value = form?.country?.authorizedPersonDetails?.birthplace ?? '';
        document.querySelector('#dob').value = form?.country?.authorizedPersonDetails?.dob ?? '';
        document.querySelector('#contractNumber').value = form?.country?.carrierDetails?.contract_num ?? '';
        document.querySelector('#carrierName').value = form?.country?.carrierDetails?.carrier_name ?? '';
        document.querySelector('#carrierAddress').value = form?.country?.carrierDetails?.carrier_address ?? '';
        setCompanyName(form?.country?.customerDetails?.company_name ?? '');
        setCity(form?.country?.customerDetails?.city ?? '');
        setStreet(form?.country?.customerDetails?.street ?? '');
        setStreetNumber(form?.country?.customerDetails?.street_num ?? '');
        setZip(form?.country?.customerDetails?.zip ?? '');
        setProvince(form?.country?.customerDetails?.province ?? '');
        setVat(form?.country?.customerDetails?.vat ?? '');
        setCompanyRegistrationNumber(form?.country?.customerDetails?.company_registration_num ?? '');
        setCompanyRegistrationName(form?.country?.customerDetails?.company_registration_name ?? '');
        setPhysicalCode(form?.country?.customerDetails?.physical_code ?? '');
        setRea(form?.country?.customerDetails?.rea ?? '');
        setAuthorisedPerson(form?.country?.authorizedPersonDetails?.authorised_person ?? '');
        setIdNumber(form?.country?.authorizedPersonDetails?.id_num ?? '');
        setRole(form?.country?.authorizedPersonDetails?.role ?? '');
        setBirthplace(form?.country?.authorizedPersonDetails?.birthplace ?? '');
        setDob(form?.country?.authorizedPersonDetails?.dob ?? '');
        setContractNumber(form?.country?.carrierDetails?.contract_num ?? '');
        setCarrierName(form?.country?.carrierDetails?.carrier_name ?? '');
        setCarrierAddress(form?.country?.carrierDetails?.carrier_address ?? '');

        //single number
        document.querySelector('#singleNum').value = form?.country?.portedNumberDetails?.number ?? '';
        document.querySelector('#singleType').value = form?.country?.portedNumberDetails?.type ?? '';
        document.querySelector('#secretCode').value = form?.country?.portedNumberDetails?.secret_code ?? '';
        setSingleNum(form?.country?.portedNumberDetails?.number ?? '')
        setSingleType(form?.country?.portedNumberDetails?.type ?? '')
        setSecretCode(form?.country?.portedNumberDetails?.secret_code ?? '');

        //range
        setTableData(form?.country?.portedNumberDetails?.numbers ?? [{ id: Date.now(), rangeStart: '', rangeStop: '' }]);
        document.querySelector('#rangeType').value = form?.country?.portedNumberDetails?.typeRange ?? '';
        document.querySelector('#date').value = form?.country?.portedNumberDetails?.date ?? '';
        setRangeType(form?.country?.portedNumberDetails?.typeRange ?? '')
        setDate(form?.country?.portedNumberDetails?.date ?? '')
    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableData, setTableData] = useState([{ id: Date.now(), rangeStart: '', rangeStop: '' }]);

    //adding a row
    const addRow = () => {
        setTableData([...tableData, { id: Date.now(), rangeStart: '', rangeStop: '' }]);
    };

    //removing a row
    const removeRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    // change handler of table
    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });

        setTableData(updatedData);

    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            const dataRows = jsonData.slice(1);

            const formattedRows = dataRows.map((row, index) => {
                const start = row[0]?.toString() || '';
                const stop = row[1]?.toString() || '';
                return {
                    id: index + 1,
                    rangeStart: start,
                    rangeStop: stop,
                };
            });

            setTableData(formattedRows);

            // Validate all rows
            const updatedValidation = {};
            formattedRows.forEach(row => {
                const start = row.rangeStart;
                const stop = row.rangeStop;

                const isStartValid = /^\d{7,10}$/.test(start);
                const isStopValid = /^\d{7,10}$/.test(stop);

                const numericStart = parseInt(start, 10);
                const numericStop = parseInt(stop, 10);

                updatedValidation[`start-${row.id}`] = isStartValid;
                updatedValidation[`end-${row.id}`] = isStopValid;

                // Check range relationship
                // if (
                //     isStartValid &&
                //     isStopValid &&
                //     numericStop < numericStart
                // ) {
                //     updatedValidation[`start-${row.id}`] = false;
                //     updatedValidation[`end-${row.id}`] = false;
                // }
            });

            setValidationStates(updatedValidation);
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableData([{ id: Date.now(), FirstNumber: '', LastNumber: '', Count: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Italy",
            "customerDetails": {
                "company_name": companyName || '',
                "city": city || '',
                "street": street || '',
                "street_num": streetNumber || '',
                "zip": zip || '',
                "province": province || '',
                "vat": vat || '',
                "company_registration_num": companyRegistrationNumber || '',
                "company_registration_name": companyRegistrationName || '',
                "physical_code": physicalCode || '',
                "rea": rea || ''
            },
            "authorizedPersonDetails": {
                "authorised_person": authorisedPerson || '',
                "id_num": idNumber || '',
                "role": role || '',
                "birthplace": birthplace || '',
                "dob": dob || ''
            },
            "carrierDetails": {
                "contract_num": contractNumber || '',
                "carrier_name": carrierName || '',
                "carrier_address": carrierAddress || ''
            },
            "portedNumberDetails": {
                "number": singleNum || '',
                "type": singleType || '',
                "secret_code": secretCode || '',
                "numbers": tableData || [],
                "typeRange": rangeType || '',
                "date": date
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};
        // paragraph
        if (!companyName) {
            validationErrors.companyName = 'Please fill the Company Name.';
        }
        if (!city) {
            validationErrors.city = 'Please fill the City.';
        }
        if (!street) {
            validationErrors.street = 'Please fill the Street.';
        }
        if (!streetNumber) {
            validationErrors.streetNumber = 'Please fill the Street Number.';
        }
        if (!zip) {
            validationErrors.zip = 'Please fill the Zip Code.';
        }
        if (!province) {
            validationErrors.province = 'Please fill the Province.';
        }
        if (!vat) {
            validationErrors.vat = 'Please fill the VAT Number.';
        }
        if (!companyRegistrationNumber) {
            validationErrors.companyRegistrationNumber = 'Please fill the Company Registration Number.';
        }
        if (!companyRegistrationName) {
            validationErrors.companyRegistrationName = 'Please fill the Company Registration Name.';
        }
        if (!physicalCode) {
            validationErrors.physicalCode = 'Please fill the Physical Code.';
        }
        if (!rea) {
            validationErrors.rea = 'Please fill the REA.';
        }
        if (!authorisedPerson) {
            validationErrors.authorisedPerson = 'Please fill the Authorized Person to sign LOA.';
        }
        if (!idNumber) {
            validationErrors.idNumber = 'Please fill the ID Number.';
        }
        if (!role) {
            validationErrors.role = 'Please fill the Role.';
        }
        if (!birthplace) {
            validationErrors.birthplace = 'Please fill the City of Birth.';
        }
        if (!dob) {
            validationErrors.dob = 'Please fill the Date of Birth.';
        }
        if (!contractNumber) {
            validationErrors.contractNumber = 'Please fill the Number of Contract at the Losing Carrier.';
        }
        if (!carrierName) {
            validationErrors.carrierName = 'Please fill the Losing Carrier Name.';
        }
        if (!carrierAddress) {
            validationErrors.carrierAddress = 'Please fill the Legal Site / Address of the Losing Carrier.';
        }
        //single num
        if (!singleType && singleNum !== '') {
            validationErrors.singleType = 'Please fill the Type.';
        }
        if (!secretCode && singleNum !== '') {
            validationErrors.secretCode = 'Please fill the Secret Code.';
        }
        //range
        tableData.forEach((row, index) => {
            if (row.rangeStart === '' && row.rangeStop !== '') {
                validationErrors[`start-${row.id}`] = `Please fill the start number in the range.`;
            }
            if (!row.rangeStop && row.rangeStart !== '') {
                validationErrors[`end-${row.id}`] = `Please fill the last number in the range.`;
            }
            if (row.rangeStart !== '' && row.rangeStop !== '' && !rangeType) {
                validationErrors.rangeType = "Please fill the type for the range.";
            }

        });
        //date
        if (!date) {
            validationErrors.date = "Please fill the Date.";
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            console.log(validationStates)
            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            console.log(firstError)
            const firstErrorKey = Object.keys(validationErrors)[0];
            console.log(firstErrorKey)
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        console.log(falseKeys)

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = companyName + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>
                {/* customer details */}

                <p><strong>Mandatory fields are marked by*</strong></p> <br></br>

                <h2 className='heading'>Customer Details</h2> <br></br>
                <Row>
                    {/* company name */}
                    <Col
                        onMouseEnter={() => handleMouseEnter('companyName')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Company Name*</label> <br />
                        <input
                            onChange={(e) => setCompanyName(e.target.value)}
                            type="text"
                            id="companyName"
                            placeholder=""
                            className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                            onBlur={() => validateInput('companyName', /^[a-zA-Z0-9\s\W]+$/)}

                        />
                        {hoveredField === 'companyName' && (
                            <div className="hover-description">
                                Enter company name.
                            </div>
                        )}
                    </Col>
                    {/* city */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`city`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>City*</label> <br />
                        <input
                            id="city" // Unique ID
                            type="text"
                            name="city"
                            onChange={(e) => setCity(e.target.value)}
                            className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`city`, /^[a-zA-Z\s\W]+$/)}
                        />
                        {hoveredField === `city` && (
                            <div className="hover-description">
                                Enter city.
                            </div>
                        )}
                    </Col>
                    {/* street */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`street`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Street*</label> <br />
                        <input
                            id="street" // Unique ID
                            type="text"
                            name="street"
                            onChange={(e) => setStreet(e.target.value)}
                            className={`inputbox ${validationStates.street === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`street`, /^[a-zA-Z\s\W]+$/)}
                        />
                        {hoveredField === `street` && (
                            <div className="hover-description">
                                Enter street name.
                            </div>
                        )}
                    </Col>
                </Row>
                <Row>
                    {/* street number */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`streetNumber`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Street Number*</label> <br />
                        <input
                            id="streetNumber" // Unique ID
                            type="text"
                            name="streetNumber"
                            onChange={(e) => setStreetNumber(e.target.value)}
                            className={`inputbox ${validationStates.streetNumber === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`streetNumber`, /^[a-zA-Z0-9\s\W]+$/)}
                        />
                        {hoveredField === `streetNumber` && (
                            <div className="hover-description">
                                Enter street number.
                            </div>
                        )}
                    </Col>
                    {/* zip */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`zip`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>ZIP Code*</label> <br />
                        <input
                            id='zip' // Unique ID
                            type="text"
                            name="zip"
                            onChange={(e) => setZip(e.target.value)}
                            className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`zip`, /^[\d\s]+$/)}
                        />
                        {hoveredField === `zip` && (
                            <div className="hover-description">
                                Enter zip code.
                            </div>
                        )}
                    </Col>
                    {/* Province */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`province`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Province*</label> <br />
                        <input
                            id="province" // Unique ID
                            type="text"
                            name="province"
                            onChange={(e) => setProvince(e.target.value)}
                            className={`inputbox ${validationStates.province === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`province`, /^[a-zA-Z\s\W]+$/)}
                        />
                        {hoveredField === `province` && (
                            <div className="hover-description">
                                Enter province.
                            </div>
                        )}
                    </Col>
                </Row>
                <Row>
                    {/* VAT number*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter('vat')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>VAT Number*</label> <br />
                        <input
                            onChange={(e) => {
                                setVat(e.target.value)
                            }}
                            type="text"
                            id="vat"
                            placeholder=""
                            className={`inputbox ${validationStates.vat === false ? 'error' : ''}`}
                            onBlur={() => validateInput('vat', /^[a-zA-Z0-9\s\W]+$/)

                            }

                        />
                        {hoveredField === 'vat' && (
                            <div className="hover-description">
                                Enter VAT Number.
                            </div>
                        )}
                    </Col>
                    {/* company registration number */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`companyRegistrationNumber`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Company Registration Number*</label> <br />
                        <input
                            id='companyRegistrationNumber' // Unique ID
                            type="text"
                            name="companyRegistrationNumber"
                            onChange={(e) => setCompanyRegistrationNumber(e.target.value)}
                            className={`inputbox ${validationStates.companyRegistrationNumber === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`companyRegistrationNumber`, /^[\d\s]+$/)}
                        />
                        {hoveredField === `companyRegistrationNumber` && (
                            <div className="hover-description">
                                Enter Company Registration Number
                            </div>
                        )}
                    </Col>
                    {/* company register names*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter('companyRegistrationName')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Company Registration Name*</label> <br />
                        <input
                            onChange={(e) => setCompanyRegistrationName(e.target.value)}
                            type="text"
                            id="companyRegistrationName"
                            placeholder=""
                            className={`inputbox ${validationStates.companyRegistrationName === false ? 'error' : ''}`}
                            onBlur={() => validateInput('companyRegistrationName', /^[a-zA-Z0-9\s\W]+$/)}

                        />
                        {hoveredField === 'companyRegistrationName' && (
                            <div className="hover-description">
                                Enter Company Registration Name
                            </div>
                        )}
                    </Col>
                </Row>
                <Row>
                    {/* physical code*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter('physicalCode')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Physical Code*</label> <br />
                        <input
                            onChange={(e) => setPhysicalCode(e.target.value)}
                            type="text"
                            id="physicalCode"
                            placeholder=""
                            className={`inputbox ${validationStates.physicalCode === false ? 'error' : ''}`}
                            onBlur={() => validateInput('physicalCode', /^[a-zA-Z0-9\s]+$/)}

                        />
                        {hoveredField === 'physicalCode' && (
                            <div className="hover-description">
                                Enter Physical Code.
                            </div>
                        )}
                    </Col>
                    {/* REA */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`rea`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>REA*</label> <br />
                        <input
                            id='rea' // Unique ID
                            type="text"
                            name="rea"
                            onChange={(e) => setRea(e.target.value)}
                            className={`inputbox ${validationStates.rea === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`rea`, /^[\d\s]+$/)}
                        />
                        {hoveredField === `rea` && (
                            <div className="hover-description">
                                Enter REA Code.
                            </div>
                        )}
                    </Col>
                </Row>
                <br></br><br></br>
                {/* authorised person details */}
                <h2 className='heading'>Authorized Person Details</h2> <br></br>
                <Row>
                    {/* authorised person */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`authorisedPerson`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Authorized Person to sign LOA*</label> <br />
                        <input
                            id="authorisedPerson" // Unique ID
                            type="text"
                            name="authorisedPerson"
                            onChange={(e) => setAuthorisedPerson(e.target.value)}
                            className={`inputbox ${validationStates.authorisedPerson === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`authorisedPerson`, /^[a-zA-Z\s]+$/)}
                        />
                        {hoveredField === `authorisedPerson` && (
                            <div className="hover-description">
                                Enter Authorized Person to sign LOA.
                            </div>
                        )}
                    </Col>
                    {/* ID number*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter('idNumber')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>ID number*</label> <br />
                        <input
                            onChange={(e) => setIdNumber(e.target.value)}
                            type="text"
                            id="idNumber"
                            placeholder=""
                            className={`inputbox ${validationStates.idNumber === false ? 'error' : ''}`}
                            onBlur={() => validateInput('idNumber', /^[a-zA-Z0-9\s]+$/)}

                        />
                        {hoveredField === 'idNumber' && (
                            <div className="hover-description">
                                Enter ID number.
                            </div>
                        )}
                    </Col>
                    {/* role*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`role`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Role*</label> <br />
                        <input
                            id="role" // Unique ID
                            type="text"
                            name="role"
                            onChange={(e) => setRole(e.target.value)}
                            className={`inputbox ${validationStates.role === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`role`, /^[a-zA-Z\s]+$/)}
                        />
                        {hoveredField === `role` && (
                            <div className="hover-description">
                                Enter Role.
                            </div>
                        )}
                    </Col>

                </Row>
                <Row>
                    {/* birth city*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`birthplace`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>City of Birth*</label> <br />
                        <input
                            id="birthplace" // Unique ID
                            type="text"
                            name="birthplace"
                            onChange={(e) => setBirthplace(e.target.value)}
                            className={`inputbox ${validationStates.birthplace === false ? 'error' : ''}`}
                            onBlur={() => validateInput(`birthplace`, /^[a-zA-Z\s]+$/)}
                        />
                        {hoveredField === `birthplace` && (
                            <div className="hover-description">
                                Enter city of birth.
                            </div>
                        )}
                    </Col>
                    {/* dob */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`dob`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Date of Birth*</label> <br />
                        <input
                            onChange={(e) => setDob(e.target.value)}
                            type="date"
                            id="dob"
                            value={dob} // Automatically set the current date
                            className={`inputbox ${validationStates.dob === false ? 'error' : ''}`}
                            onBlur={() => validateInput('dob', /^.*$/)}
                        />
                        {hoveredField === `dob` && (
                            <div className="hover-description">
                                Enter Date of Birth
                            </div>
                        )}
                    </Col>
                </Row>
                <br></br><br></br>
                {/* carrier details */}
                <h2 className='heading'>Carrier Details</h2> <br></br>
                <Row>
                    {/* contract number*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter('contractNumber')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Number of contract at the losing carrier*</label> <br />
                        <input
                            onChange={(e) => setContractNumber(e.target.value)}
                            type="text"
                            id="contractNumber"
                            placeholder=""
                            className={`inputbox ${validationStates.contractNumber === false ? 'error' : ''}`}
                            onBlur={() => validateInput('contractNumber', /^[a-zA-Z0-9\s]+$/)}

                        />
                        {hoveredField === 'contractNumber' && (
                            <div className="hover-description">
                                Enter Number of contract at the losing carrier.
                            </div>
                        )}
                    </Col>
                    {/* carrier name*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter('carrierName')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Losing Carrier Name*</label> <br />
                        <input
                            onChange={(e) => setCarrierName(e.target.value)}
                            type="text"
                            id="carrierName"
                            placeholder=""
                            className={`inputbox ${validationStates.carrierName === false ? 'error' : ''}`}
                            onBlur={() => validateInput('carrierName', /^[a-zA-Z0-9\s]+$/)}

                        />
                        {hoveredField === 'carrierName' && (
                            <div className="hover-description">
                                Enter Losing Carrier Name.
                            </div>
                        )}
                    </Col>
                    {/* carrier address*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter('carrierAddress')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Legal site / Address of the losing carrier*</label> <br />
                        <input
                            onChange={(e) => setCarrierAddress(e.target.value)}
                            type="text"
                            id="carrierAddress"
                            placeholder=""
                            className={`inputbox ${validationStates.carrierAddress === false ? 'error' : ''}`}
                            onBlur={() => validateInput('carrierAddress', /^[a-zA-Z0-9\s\W]+$/)}

                        />
                        {hoveredField === 'carrierAddress' && (
                            <div className="hover-description">
                                Enter Legal site / Address of the losing carrier
                            </div>
                        )}
                    </Col>
                </Row>


                <br></br><br></br>
                {/* Number */}
                <h2 className='heading'>Ported number details</h2> <br></br>
                <Row>
                    {/* Single main Number */}
                    <Col
                        onMouseEnter={() => handleMouseEnter(`singleNum`)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Single main number (as shown on the bill)</label> <br />
                        <input
                            id='singleNum' // Unique ID
                            type="text"
                            name="singleNum"
                            onChange={(e) => {
                                setSingleNum(e.target.value)
                                if (e.target.value !== '' && !/^[\d\s]+$/.test(e.target.value)) {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`singleNum`]: false,
                                    }));
                                } else {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`singleNum`]: true,
                                    }));
                                }
                            }}
                            className={`inputbox ${validationStates.singleNum === false && singleNum !== '' ? 'error' : ''}`}
                            onBlur={() => {
                                if (singleNum === '' && validationStates.secretCode === false) {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`secretCode`]: true,
                                    }))
                                }
                                if (singleNum === '' && validationStates.singleType === false) {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`singleType`]: true,
                                    }))
                                }

                            }}
                        />
                        {hoveredField === `singleNum` && (
                            <div className="hover-description">
                                Enter Number.
                            </div>
                        )}
                    </Col>
                    {/* type */}
                    <Col
                        onMouseEnter={() => handleMouseEnter('singleType')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Typology</label> <br />
                        <select
                            id="singleType"
                            onChange={(e) => {
                                setSingleType(e.target.value)
                                if (e.target.value !== '' && !/^.*$/.test(e.target.value)) {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`singleType`]: false,
                                    }));
                                } else {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`singleType`]: true,
                                    }));
                                }
                            }}
                            className={`inputbox ${validationStates.singleType === false ? 'error' : ''}`}
                        // onBlur={() => validateInput('type', /^.*$/)}
                        >
                            <option value=""></option>
                            <option value="PSTN-ISDN">
                                PSTN-ISDN
                            </option>
                            <option value="Charge to the called party">
                                Charge to the called party
                            </option>
                            <option value="Shared Charge">
                                Shared Charge
                            </option>
                            <option value="Nomadic">
                                Nomadic
                            </option>
                        </select>
                        {hoveredField === 'singleType' && (
                            <div className="hover-description">
                                Enter typology.
                            </div>
                        )}
                    </Col>
                    {/* secret code*/}
                    <Col
                        onMouseEnter={() => handleMouseEnter('secretCode')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Secret Code (as indicated on the bill)</label> <br />
                        <input
                            onChange={(e) => {
                                setSecretCode(e.target.value)
                                if (e.target.value !== '' && !/^[a-zA-Z0-9\s\W]+$/.test(e.target.value)) {
                                    toast.error('The secret code is not valid')
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`secretCode`]: false,
                                    }));
                                } else {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`secretCode`]: true,
                                    }));
                                }
                            }}
                            type="text"
                            id="secretCode"
                            placeholder=""
                            className={`inputbox ${validationStates.secretCode === false ? 'error' : ''}`}
                        // onBlur={() => validateInput('secretCode', /^[a-zA-Z0-9\s\W]+$/)}

                        />
                        {hoveredField === 'secretCode' && (
                            <div className="hover-description">
                                Enter code as in the  bill.
                            </div>
                        )}
                    </Col>
                </Row>
                <br></br><br></br>
                {/* range */}
                <h2 className='heading'>Numbering Range</h2> <br></br>
                <Row>
                    {/* Number range */}
                    <Container>

                        <Row>
                            <Col xs={5}>
                                <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                    Download BTD Number Template
                                </button>
                            </Col>

                            <Col>
                                <button
                                    variant="secondary"
                                    className="inputbox"
                                    style={{ alignItems: 'center' }}
                                    onClick={() => fileInputRef.current.click()}
                                >
                                    <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                    Upload file
                                </button>
                                <input
                                    id="fileUploadInput"
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileUpload}
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                />
                            </Col>

                            <Col>
                                {uploadedFileName && (
                                    <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                        <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                        Remove
                                    </button>
                                )}
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                {uploadedFileName && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                        <p style={{ marginRight: '10px' }}>Uploaded file: {uploadedFileName}</p>
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <br />
                        <p>The template is the same used for the btd portability request.</p>
                        <br />

                        <Table striped bordered hover variant="light">
                            <thead>
                                <tr>
                                    <th>Start Range</th>
                                    <th>End Range</th>
                                </tr>
                            </thead>
                            <tbody>

                                {tableData.map(row => (
                                    <tr key={row.id}>

                                        <td
                                            onMouseEnter={() => handleMouseEnter(`start-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                id={`start-${row.id}`} // Dynamic ID for start input
                                                value={row.rangeStart}
                                                onChange={(e) => {
                                                    const value = e.target.value
                                                    handleChange_table(row.id, 'rangeStart', value)
                                                    // Immediate validation feedback for 7-10 digits only when not empty
                                                    if (value !== '' && !/^\d+$/.test(value)) {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`start-${row.id}`]: false,
                                                        }));
                                                    } else {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`start-${row.id}`]: true,
                                                        }));
                                                    }
                                                }}
                                                className={`inputbox ${validationStates[`start-${row.id}`] === false && row.rangeStart !== '' ? 'error' : ''}`}
                                                onBlur={(e) => {
                                                    const startValue = e.target.value;
                                                    const start = parseInt(startValue, 10);
                                                    const end = parseInt(row.rangeStop, 10);

                                                    // Validate the input for exactly 7-10 digits
                                                    if (row.rangeStart !== '' && !/^\d+$/.test(startValue)) {
                                                        toast.error("The initial interval must be a numeric value.");
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`start-${row.id}`]: false,
                                                        }));
                                                    } else {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`start-${row.id}`]: true,
                                                        }));

                                                        // Check if end range is valid
                                                        if (row.rangeStop) {
                                                            if (end < start) {
                                                                toast.error("The final interval must be greater than or equal to the initial interval.");
                                                                setValidationStates(prev => ({
                                                                    ...prev,
                                                                    [`end-${row.id}`]: false,
                                                                }));
                                                            } else {
                                                                setValidationStates(prev => ({
                                                                    ...prev,
                                                                    [`end-${row.id}`]: true,
                                                                }));
                                                            }
                                                        }
                                                    }
                                                    if (row.rangeStart === '' && validationStates.rangeType === false) {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`rangeType`]: true,
                                                        }))
                                                    }
                                                }}
                                            />
                                            {hoveredField === `start-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter number
                                                </div>
                                            )}
                                            {validationStates[`start-${row.id}`] === false && row.rangeStart !== '' && (
                                                <div className="error-message">
                                                    The initial interval must be a numeric value.
                                                </div>
                                            )}
                                        </td>
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`end-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                id={`end-${row.id}`} // Dynamic ID for end input
                                                value={row.rangeStop}
                                                onChange={(e) => {
                                                    const value = e.target.value
                                                    handleChange_table(row.id, 'rangeStop', value)
                                                    // Immediate validation feedback for 7-10 digits only when not empty
                                                    if (value !== '' && !/^\d+$/.test(value)) {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`end-${row.id}`]: false,
                                                        }));
                                                    } else {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`end-${row.id}`]: true,
                                                        }));
                                                    }
                                                }
                                                }

                                                className={`inputbox ${validationStates[`end-${row.id}`] === false && row.rangeStop !== '' ? 'error' : ''}`}
                                                onBlur={(e) => {
                                                    const endValue = e.target.value;
                                                    const start = parseInt(row.rangeStart, 10);
                                                    const end = parseInt(endValue, 10);

                                                    // Validate the input for exactly 10 digits
                                                    if (row.rangeStop !== '' && !/^\d+$/.test(endValue)) {
                                                        toast.error("The final range must be a numeric value.");
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`end-${row.id}`]: false,
                                                        }));
                                                    } else {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`end-${row.id}`]: true,
                                                        }));

                                                        // Check if end range is valid
                                                        if (row.rangeStart) {
                                                            if (end < start) {
                                                                toast.error("The final interval must be greater than or equal to the initial interval.");
                                                                setValidationStates(prev => ({
                                                                    ...prev,
                                                                    [`start-${row.id}`]: false,
                                                                    [`end-${row.id}`]: false,
                                                                }));
                                                            } else {
                                                                setValidationStates(prev => ({
                                                                    ...prev,
                                                                    [`start-${row.id}`]: true,
                                                                    [`end-${row.id}`]: true,
                                                                }));
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                            {hoveredField === `end-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter number
                                                </div>
                                            )}
                                            {validationStates[`end-${row.id}`] === false && row.rangeStop !== '' && (
                                                <div className="error-message">
                                                    The final range must be a numeric value.
                                                </div>
                                            )}
                                        </td>

                                    </tr>
                                ))}

                            </tbody>
                        </Table>

                        {/* <button onClick={addRow}>Add Row</button> */}

                    </Container>
                </Row>
                <Row>
                    {/* type */}
                    <Col
                        onMouseEnter={() => handleMouseEnter('rangeType')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Typology</label> <br />
                        <select
                            id="rangeType"
                            onChange={(e) => {
                                setRangeType(e.target.value)
                                if (e.target.value !== '' && !/^.*$/.test(e.target.value)) {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`rangeType`]: false,
                                    }));
                                } else {
                                    setValidationStates(prev => ({
                                        ...prev,
                                        [`rangeType`]: true,
                                    }));
                                }
                            }}
                            className={`inputbox ${validationStates.rangeType === false ? 'error' : ''}`}
                        // onBlur={() => validateInput('rangeType', /^.*$/)}
                        >
                            <option value=""></option>
                            <option value="PSTN-ISDN">
                                PSTN-ISDN
                            </option>
                            <option value="Charge to the called party">
                                Charge to the called party
                            </option>
                            <option value="Shared Charge">
                                Shared Charge
                            </option>
                            <option value="Nomadic">
                                Nomadic
                            </option>
                        </select>
                        {hoveredField === 'rangeType' && (
                            <div className="hover-description">
                                Choose one typology
                            </div>
                        )}
                    </Col>
                </Row>

                <br></br>

                <Row>
                    <Col>
                        <label>Date*</label> <br />
                        <input
                            onChange={(e) => setDate(e.target.value)}
                            type="date"
                            id="date"
                            value={date} // Automatically set the current date
                            className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                            onBlur={() => validateInput('date', /^.*$/)}
                            min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                        />
                    </Col>
                </Row>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generare LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default ItalyEnglish;